import type { Control } from "react-hook-form";
import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InvestmentAdditionalFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentAdditionalFields";
import { InvestmentBasicFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentBasicFields";
import { InvestmentToolsSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentToolsSection";
import { InvestmentValuesSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentValuesSection";
import type {
	InvestmentCreateFormInput,
	InvestmentCreateFormOutput,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";

type InvestmentCreateFormFieldsProps = {
	control: Control<
		InvestmentCreateFormInput,
		unknown,
		InvestmentCreateFormOutput
	>;
};

export const InvestmentCreateFormFields = ({
	control,
}: InvestmentCreateFormFieldsProps) => {
	const { t } = useResource();

	return (
		<>
			<InvestmentBasicFields
				control={control}
				domain={ClientPortfolioDomainEnum.Investments}
				namePlaceholder={t(Resources.Portfolio.AddInvestment.Placeholders.name)}
			/>
			<InvestmentValuesSection control={control} />
			<InvestmentToolsSection control={control} mergeDuplicateIsin />
			<InvestmentAdditionalFields control={control} />
		</>
	);
};
